<template>
        <div class="mb-3">
            <label for="image_input" class="form-label">Item Images</label>
            <br>
            <div class="container-fluid g-0">
            <div class="row">
                <div v-for="image in images" class="col-3">
                    <img class="rounded img-fluid my-2" style="width: 100%;" :src='URL(image.path)'>
                    <button type="button" class="btn btn-warning delete-image-button" @click="Delete(image.id)">
                        <i class="fas fa-trash"></i> Delete
                    </button>
                </div>
            </div>
        </div>

        <br>

        <input type="file" v-for="n in this.newImageCount" class="form-control image-input my-2" :name="`image[${n}]`">

        <button type="button" @click="this.AddImage()" class="btn btn-warning">
            <i class="fas fa-plus"></i> Add Another
        </button>
    </div>
</template>

<script>
export default {

    data () {
        return {
            images: [],
            newImageCount: 0
        }
    },

    props: ['items'],

    created () {
        this.images = this.items;
    },

    methods: {

        URL (path) {
            return window.location.origin + '/storage/' + path;
        },

        async AddImage () {
            this.newImageCount++;
	    },

        async Delete(id) {
            const response = await axios.post(`/admin/delete_image`, { id: id });
            const key = this.images.findIndex(a => a.id == id);
            this.images.splice(key, 1);
  		    Toast("Image Has Been Deleted");
        }

    }

}
</script>